<template>
  <div class="access-view">
    <div class="card">
      <div class="card-header">
        <h6 class="mb-0">
          <font-awesome-icon icon="question-circle" />
          {{ $t("access.title") }}
        </h6>
      </div>
      <div class="card-body">
        <div class="card-text">
          <div class="d-flex justify-content-center">
            <a
              href="https://www.ovhtelecom.fr/manager/"
              role="button"
              class="btn btn-outline-primary"
              target="_blank"
            >
              <font-awesome-icon icon="tachometer-alt" />
              {{ $t("access.button-title") }}
            </a>
          </div>
          <div class="description">
            {{ $t("access.description") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessView",
};
</script>

<style>
.access-view {
  margin-top: 1rem;
}
.description {
  margin: 1rem;
  width: 280px;
  font-size: 0.9rem;
}
</style>